import styled from 'styled-components'

export const StyledNewsCategory = styled.div`
  display: flex;
  column-gap: 6px;
  width: calc(100% - 55px);
`
